﻿import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Icon, Table, Modal } from 'antd';

import { Clausula, UpdateStatusItemNivel1 } from '../../../api/minuta/Clausula';
import { Item, putAtualizarDescricaoItem, getAllItemByClausulaId } from '../../../api/minuta/ItemClausula';
import ModalComentarioItem from './ModalComentarioItem';
import ModalJustificativaReprovacao from './ModalJustificativaReprovacao';
import { Button } from '@digital/ui';

interface TabelaItemProps {
  clausulaResult: Clausula;
  getAllClausula: () => any;
  setGetList: React.Dispatch<React.SetStateAction<boolean>>;
  getList: boolean;
}

const TabelaItemParaAprovacao = (props: TabelaItemProps) => {
  const { clausulaResult, getAllClausula, setGetList, getList } = props;
  const [clausula, setClausula] = useState<Clausula>(clausulaResult);
  const [exibirModal, setExibirModal] = useState(false);
  const idItem = useRef<string>('');

  const onUpdate = () => {
    setGetList(!getList);
  };

  const { confirm } = Modal;
  function aprovarItem(id: string) {
    confirm({
      title: 'Aprovar Item',
      icon: <Icon type="info-circle" />,
      content: 'Deseja realmente aprovar o item?',
      onOk() {
        UpdateStatusItemNivel1({ id }).then(data => onUpdate());
      },
      onCancel() {},
    });
  }

  useEffect(() => {
    getAllClausula();
  }, [getAllClausula, getList]);

  useMemo(() => {
    setClausula(clausulaResult);
  }, [clausulaResult]);

  const collunsItem = [
    {
      key: 'ordem',
      title: 'Ordem',
      dataIndex: 'ordem',
      width: '5%',
    },
    {
      key: 'descricao',
      title: 'Item',
      dataIndex: 'descricao',
      width: '90%',
      render: (index: any, record: any, rowKey: any) => {
        if (record.editavel != true) {
          return <div>{record.descricao}</div>;
        }
      },
    },
    {
      key: 'comentario',
      title: 'Comentário',
      dataIndex: 'comentario',
      width: '5%',
      render: (index: any, record: any, rowKey: any) => {
        return <ModalComentarioItem linhaItemId={record.id} contemComentario={record.contemComentario} />;
      },
    },
    {
      key: 'revisao',
      title: 'Revisão',
      dataIndex: 'revisao',
      width: '5%',
      render: (index: any, record: any, rowKey: any) => {
        return <div>{record.revisao}</div>;
      },
    },
    {
      key: 'acoes',
      title: 'Ações',
      isDummyField: true,
      width: '5%',
      render: (index: any, record: any, rowkey: any) => {
        return [
          <Button
            key="aprovar"
            icon="commons-ok"
            size="large"
            onClick={() => {
              aprovarItem(index.id);
            }}
          />,
          <Button
            icon="commons-cancel"
            key="reprovar"
            size="large"
            onClick={() => {
              idItem.current = index.id;
              setExibirModal(true);
            }}
          />,
        ];
      },
    },
  ];

  return (
    <>
      <Table dataSource={clausula.itens} rowKey={'id'} columns={collunsItem} />
      <ModalJustificativaReprovacao
        onUpdate={onUpdate}
        exibirModal={exibirModal}
        setExibirModal={setExibirModal}
        idItem={idItem.current}
      />
    </>
  );
};

export default TabelaItemParaAprovacao;
